import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
@Component({
  selector: 'app-social-share-link',
  templateUrl: './social-share-link.component.html',
  styleUrls: ['./social-share-link.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SocialShareLinkComponent implements OnInit {
  @Input() settingsData: any;
  copyUrl: string;
  env: any;
  isShow: any = false;
  textboxUrl: string;
  textAreaUrl: any;
  @Input() slugName;
  assets_url = environment.assets_url;
  productsList:any;
  slugInfoSubscr:any; 
  slugInfo:any;
  dynamicSettingsData:any;
  @Input() sharedFrom; // To check from which page it is being shared
  @Input() channelName; // To check from which page it is being shared
  @Output() closeShareEvent = new EventEmitter<string>();

  constructor(
    public router: Router,
    private toastr: ToastrService,
    private commanSubscribeService:CommanSubscribeService
  ) { 
    this.slugInfo = this.commanSubscribeService.slugInfo;
    if(this.slugInfo){
      this.slugName = this.slugInfo.stream_info ? this.slugInfo.stream_info.slug : this.slugInfo.slug;
      this.ngOnInit();
    }
    this.slugInfoSubscr = this.commanSubscribeService.getSlugData().subscribe(response => {
      this.slugInfo = response;
      this.slugName = this.slugInfo.stream_info ? this.slugInfo.stream_info.slug : this.slugInfo.slug;
      this.ngOnInit();
    });
  }

  ngOnInit() {
    this.channelName = this.channelName || this.router.url.split("/")[1];
    if(this.settingsData){
      this.dynamicSettingsData=this.settingsData
    }else{
      this.dynamicSettingsData='';
    }
    this.commanSubscribeService.getActiveProductsList().subscribe(response=>{
      this.productsList=response;
    })
    if(this.sharedFrom == "albums"){
      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}`;
      return;
    }
    if(this.sharedFrom == "product" || this.sharedFrom == "nft"){
      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}`;
      return;
    }
    if(this.sharedFrom=='album'){          // For audio and video sharing
      let splitSlug=this.slugName.split('/');
      if(splitSlug.length==5 && !splitSlug[0]){  // to remove an extra '/' before the slug
        this.slugName=splitSlug[1]+'/'+splitSlug[2]+'/'+splitSlug[3]+'/'+splitSlug[4];
      }

      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}`;
    }
    if(this.sharedFrom === 'SHARE_SPACE_LINK'){
      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}`;
      return
    }
    if(this.sharedFrom === 'album-video'){
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${this.slugName}`;
    }
    if(this.sharedFrom === 'event'){
      const urlSegments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
      const channelSeg = urlSegments[0] || this.channelName;
      const groupSlug = urlSegments[1] && !['event', 'channel', 'stream', 'album', 'subscription-list'].includes(urlSegments[1]) ? urlSegments[1] : '';
      const basePath = groupSlug ? `/${channelSeg}/${groupSlug}` : `/${channelSeg}`;
      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${basePath}/event/${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}${basePath}/event/${this.slugName}`;
      return;
    }
    else{
      // let route = this.router.url.substring(1);
      this.textAreaUrl = `<iframe src="${environment.CONSUMER_PORTAL.replace(/\/$/, '')}/${this.slugName}" width="560" height="315"  frameborder="0" allowfullscreen></iframe>`;
      //  this.copyUrl = this.embedLink.length > 30 ? this.embedLink.slice(0, 30) + '...' : this.embedLink;
      this.copyUrl = this.textboxUrl = `${environment.CONSUMER_PORTAL.replace(/\/$/, '')}/${this.slugName}`;
    }
  }

  onDisplay() {
    this.isShow = !this.isShow;
  }

  copyToClipboard(type) {
    const el = document.createElement('textarea');
    if (type == 'text-box') {
      el.value = this.copyUrl;
    } else {
      el.value = this.copyUrl;
    }
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.toastr.success("Copied..!")
    this.onCopySuccess(true)
  }

  onCopySuccess(value) {
    this.closeShareEvent.emit(value);
  }
  ngOnDestroy() {
    if(this.slugInfoSubscr){
      this.slugInfoSubscr.unsubscribe();
    }
  }
}
